import React from 'react';
import './UcMultiSectionProgressBar.scss';
import { Popover, Typography } from '@mui/material';
// @ts-ignore
import { useResponsive } from '../../lib/useResponsive';
import { useTranslation } from "react-i18next";

interface Section {
    label: string;
    percentage: number;
    color: string;
}

interface UcMultiSectionProgressBarProps {
    title?: string;
    sections: Section[];
    indicatorValue?: number;
}

const UcMultiSectionProgressBar: React.FC<UcMultiSectionProgressBarProps> = ({ title, sections, indicatorValue }) => {
    const { t } = useTranslation();
    const { isMobile } = useResponsive();
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const SafeIndicatorPosition = () => {
        if (indicatorValue === undefined || indicatorValue <= 0)
            return 1;
        else if (indicatorValue > 93)
            return 93;
        else
            return indicatorValue;
    }

    function getOrdinalSuffix(num: number) {
        const lastDigit = num % 10;
        const lastTwoDigits = num % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
            return `${num}th`;
        }

        switch (lastDigit) {
            case 1:
                return `${num}st`;
            case 2:
                return `${num}nd`;
            case 3:
                return `${num}rd`;
            default:
                return `${num}th`;
        }
    }

    return (
        <div className="progress-bar">
            {sections.map((section) => {
                return (
                    <div
                        key={`progress-bar__section__${section.percentage}`}
                        className="progress-bar__section"
                        style={{
                            width: `${section.percentage}%`,
                            backgroundColor: section.color,
                        }}
                    >
                        {isMobile ? <></> : <span className="progress-bar__label">{section.label}</span>}
                    </div>
                );
            })}
            {indicatorValue !== undefined && (
                <>
                    <div
                        className="progress-bar__indicator"
                        style={{
                            left: `${SafeIndicatorPosition()}%`,
                        }}
                        aria-haspopup="true"
                        onMouseEnter={handlePopoverOpen}
                        onMouseLeave={handlePopoverClose}
                    >
                        <span className='progress-bar__indicator__percentile'>
                            {getOrdinalSuffix(parseInt(indicatorValue.toFixed(0)))}
                        </span>
                    </div>
                    <Popover
                        id="mouse-over-popover"
                        sx={{ pointerEvents: 'none' }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Typography sx={{ p: 1 }}>{t('You\'re in the {{percentile}} percentile.', { percentile: getOrdinalSuffix(parseInt(indicatorValue.toFixed(0))) })}</Typography>
                    </Popover>
                </>
            )}
        </div>
    );
};

export default UcMultiSectionProgressBar;